import { Icon, IconProps } from './Icon';

export type RefreshProps = IconProps;

export const Refresh = (props: RefreshProps) => (
  <Icon width="20px" height="20px" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
    <path d="M1.667 8.333s.1-.707 3.03-3.636a7.5 7.5 0 0 1 12.617 3.636m-15.647 0v-5m0 5h5m11.666 3.334s-.1.707-3.03 3.636a7.5 7.5 0 0 1-12.616-3.636m15.646 0v5m0-5h-5" stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round"/>
  </Icon>
)
